import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tech-modal-order',
  templateUrl: './modal-order.component.html',
  styleUrls: ['./modal-order.component.scss']
})
export class ModalOrderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
